module.exports = __webpack_public_path__ + "img/chat-shadow.ce3a1b15.svg";